import{Z as o,d as s}from"./p-BgbgNWDg.js";const t=o;const g=s;export{t as ZprDropdownMenu,g as defineCustomElement};
//# sourceMappingURL=zpr-dropdown-menu.js.map